import React from 'react'

const Recurring_Invoices = () => {
  return (
    <div>
        Recurring Invoices Page
    </div>
  )
}

export default Recurring_Invoices
